import React from 'react';
import ActionButton from '../../../../../Components/Common/ActionButton';

// Floating action bar pinned to the bottom-right of the detail page. Which
// buttons appear is driven by the orchestrator:
//   - Back              : every tab except the first
//   - Save as Draft     : editable tabs (Requirement / Supporting Doc / DMUT)
//   - Save & Completed  : editable tabs — validates then marks the step done
//   - Submit            : Overview tab, only when all steps are Completed
// In read-only (detail) mode only Back is shown.
const FloatingActions = ({
  showBack,
  showSaveDraft,
  showSaveCompleted,
  showSubmit,
  onBack,
  onSaveDraft,
  onSaveCompleted,
  onSubmit,
}) => {
  if (!showBack && !showSaveDraft && !showSaveCompleted && !showSubmit) {
    return null;
  }

  return (
    <div
      className='d-flex gap-2 justify-content-end'
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 5,
        padding: '12px 4px',
        marginTop: '1rem',
        background:
          'linear-gradient(to top, rgba(255,255,255,0.95) 60%, rgba(255,255,255,0))',
      }}
    >
      {showBack && (
        <ActionButton
          variant='secondary'
          icon='ri-arrow-left-line'
          onClick={onBack}
        >
          Back
        </ActionButton>
      )}
      {showSaveDraft && (
        <ActionButton
          variant='secondary'
          icon='ri-draft-line'
          onClick={onSaveDraft}
        >
          Save as Draft
        </ActionButton>
      )}
      {showSaveCompleted && (
        <ActionButton
          variant='primary'
          icon='ri-check-double-line'
          onClick={onSaveCompleted}
        >
          Save &amp; Completed
        </ActionButton>
      )}
      {showSubmit && (
        <ActionButton
          variant='primary'
          icon='ri-send-plane-line'
          onClick={onSubmit}
        >
          Submit
        </ActionButton>
      )}
    </div>
  );
};

export default FloatingActions;
